import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { createCoverageAccountEpic } from './_epics/createCoverageAccount.epic';
import { updateCoverageAccountEpic } from './_epics/updateCoverageAccount.epic';
import { removeCoverageAccountEpic } from './_epics/removeCoverageAccount.epic';

// loadList has no epic here — accounts arrive embedded in GET /external-reporting/reports,
// so the coverage-report list epic emits CoverageAccountAction.loadList.* alongside its own.
export const coverageAccountEpic = safeCombineEpics(
  createCoverageAccountEpic,
  updateCoverageAccountEpic,
  removeCoverageAccountEpic,
);
